import PieChart from "components/charts/PieChart";
import {pieChartData, pieChartOptions} from "variables/charts";
import Card from "components/card";
import {useEffect, useState} from "react";

const PieChartCard = ({pieChartData = [], title = "", type = 0, extra = []}) => {
    const [pieChartOptionsState, setPieChartOptionsState] = useState(pieChartOptions);
    const [localpieData, setLocalpieData] = useState([]);
    const [showUndecided, setshowUndecided] = useState(false);


    useEffect(() => {
        if (type === 2) {
            setPieChartOptionsState({
                ...pieChartOptionsState,
                labels: ['Not Transferred', 'Transferred'],
                colors: ["#6AD2FF", "#FF9A8B", "#d3d3d3"],
                fill: {
                    colors: ["#6AD2FF", "#FF9A8B", "#d3d3d3"],
                },
            });

        } else {

            setPieChartOptionsState({
                ...pieChartOptionsState,
                labels: ['Solved', 'Unresolved', "Undecided"],
                colors: ["#6AD2FF", "#FF9A8B", "#d3d3d3"],
                fill: {
                    colors: ["#6AD2FF", "#FF9A8B", "#d3d3d3"],
                },
            });
        }


    }, [type]);


    useEffect(() => {
        if (pieChartData.length > 0 && type === 1) {
            let solvedArr = [];
            let allSolvedStatus = pieChartData;
            let decided = pieChartData.filter(n => n.toLowerCase() !== "null");

            let solvedYes = allSolvedStatus.filter(n => n.toLowerCase() === "true").length;
            let solvedNo = allSolvedStatus.filter(n => n.toLowerCase() === "false").length;

            let yesPercentage = ((solvedYes / decided.length) * 100).toFixed(2);
            let noPercentage = ((solvedNo / decided.length) * 100).toFixed(2);

            solvedArr.push(parseFloat(yesPercentage));
            solvedArr.push(parseFloat(noPercentage));

            if (showUndecided) {
                solvedArr = [];
                solvedYes = allSolvedStatus.filter(n => n.toLowerCase() === "true").length;
                solvedNo = allSolvedStatus.filter(n => n.toLowerCase() === "false").length;

                 yesPercentage = ((solvedYes / allSolvedStatus.length) * 100).toFixed(2);
                 noPercentage = ((solvedNo / allSolvedStatus.length) * 100).toFixed(2);

                solvedArr.push(parseFloat(yesPercentage));
                solvedArr.push(parseFloat(noPercentage));

                let undecidedPercentage = (100 - yesPercentage - noPercentage).toFixed(2);
                solvedArr.push(parseFloat(undecidedPercentage));

            }

            setLocalpieData(solvedArr);
        } else {
            setLocalpieData(pieChartData);
        }
    }, [showUndecided, pieChartData, type]);


    return (
        <Card extra="rounded-[20px] p-3">
            <div className="flex flex-row justify-between px-3 pt-2">

                <div className="flex flex-row w-full justify-between border-0">
                    <h4 className="text-lg font-bold text-navy-700 dark:text-white">
                        {title}
                    </h4>

                    {type === 1 &&
                        <div>
                            <label className={"cursor-pointer"}><input checked={showUndecided}
                                                                       onChange={(e) => setshowUndecided(e.target.checked)}
                                                                       type={"checkbox"}/> Show undecided</label>
                        </div>}
                </div>

                <div className="mb-6 flex items-center justify-center">
                    {/*<select className="mb-3 mr-2 flex items-center justify-center text-sm font-bold text-gray-600 hover:cursor-pointer dark:!bg-navy-800 dark:text-white">*/}
                    {/*  <option value="monthly">Monthly</option>*/}
                    {/*  <option value="yearly">Yearly</option>*/}
                    {/*  <option value="weekly">Weekly</option>*/}
                    {/*</select>*/}
                </div>
            </div>

            <div className="mb-auto flex h-[220px] w-full items-center justify-center">
                <PieChart options={pieChartOptionsState} series={localpieData}/>
            </div>
            <div
                className="flex flex-row !justify-between rounded-2xl px-6 py-3 shadow-2xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
                <div className="flex flex-col items-center justify-center">
                    <div className="flex items-center justify-center">
                        <div className="h-2 w-2 rounded-full bg-[#FF9A8B]"/>
                        <p className="ml-1 text-sm font-normal text-gray-600">{type == 1 ? "Unresolved" : "Transferred"}</p>
                    </div>
                    <p className="mt-px text-xl font-bold text-navy-700  dark:text-white">
                        {localpieData.length > 0 && localpieData[1].toFixed(2) + "%"}
                    </p>
                </div>

                <div className="h-11 w-px bg-gray-300 dark:bg-white/10"/>


                <div className="flex flex-col items-center justify-center">
                    <div className="flex items-center justify-center">
                        <div className="h-2 w-2 rounded-full bg-[#6AD2FF]"/>
                        <p className="ml-1 text-sm font-normal text-gray-600">{type == 1 ? "Solved" : "Not Transferred"}</p>
                    </div>
                    <p className="mt-px text-xl font-bold text-navy-700 dark:text-white">
                        {localpieData.length > 0 && localpieData[0].toFixed(2) + "%"}
                    </p>
                </div>

                {showUndecided && <div className="h-11 w-px bg-gray-300 dark:bg-white/10"/>}

                {showUndecided && localpieData.length > 2 &&
                    <div className="flex flex-col items-center justify-center">
                        <div className="flex items-center justify-center">
                            <div className="h-2 w-2 rounded-full bg-[#d3d3d3]"/>
                            <p className="ml-1 text-sm font-normal text-gray-600">Undecided</p>
                        </div>
                        <p className="mt-px text-xl font-bold text-navy-700 dark:text-white">
                            {localpieData[2].toFixed(2) + "%"}
                        </p>
                    </div>
                }
            </div>
        </Card>
    );
};

export default PieChartCard;
